import React from 'react';
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { Box, Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';

const colors = ['#3F51B5', '#FB8C00', '#e53935', '#4caf50', '#834bff', '#00bcd4'];

const Invoiced30Days = ({ stats, isLoading, isError }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || i18n.language || 'ro';
  const sales = stats?.last30;
  const currencies = sales?.currencies || [];
  const hasAmounts = currencies.some(({ amount }) => amount !== null && amount > 0);
  const data = {
    labels: currencies.map(({ currency }) => `${currency} → MDL`),
    datasets: [{ data: currencies.map(({ amount }) => amount), backgroundColor: colors, borderWidth: 3 }],
  };
  const options = {
    animation: false, responsive: true, maintainAspectRatio: false, cutout: '70%',
    plugins: { legend: { position: 'bottom' } },
  };
  const message = !sales ? (isError && !isLoading ? 'dashboard.load_error' : 'dashboard.loading') :
    sales.total === null ? 'dashboard.missing_exchange_rates' :
    sales.count === 0 ? 'dashboard.no_data_available_for_last_30_days' :
    !hasAmounts ? 'dashboard.no_sales_amount' : null;
  return (
    <Card>
      <CardHeader title={t('dashboard.latest_sales')} subheader={t('dashboard.in_mdl_at_nbm_exchange_rate')}
        action={<Typography variant="body2">{t('dashboard.last_30_days')}</Typography>}
        sx={{ backgroundColor: '#f1f1f1', minHeight: 85 }} />
      <Divider />
      <CardContent>
        <Stack spacing={1} sx={{ height: 375 }}>
          {message ? <Typography>{t(message)}</Typography> : (
            <>
              <Typography variant="h6" textAlign="center">
                {sales.total.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MDL
              </Typography>
              <Box sx={{ flex: 1, minHeight: 0, position: 'relative' }}><Doughnut data={data} options={options} /></Box>
              <Typography variant="body2" textAlign="center" color="text.secondary">
                {t('dashboard.invoice_count', { count: sales.count })}
              </Typography>
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default Invoiced30Days;
